export default __webpack_public_path__ + "static/media/Asset 18@0.5x.63bd1b2f.png";